import React from 'react';
import ReactDOM from 'react-dom';
import Checkbox from './Checkbox';

export default ({children, isOpen, option, showOption = false, className = '', rootClassName = 'modal-open'}) => {
  if (isOpen) {
    document.getElementById('root').classList.add(rootClassName);
  } else {
    document.getElementById('root').classList.remove(rootClassName);
  }

  return (
    ReactDOM.createPortal(
      isOpen
        ? <aside className={`ect-modal ${className}`}>
          <section className={`content ${showOption ? 'option' : ''}`}>
            {children.map((child, index) => {
              if (index === children.length - 1 && showOption) {
                return (
                  <React.Fragment>
                    <Checkbox label={option.label} value={option.value} onChange={option.onChange} />
                    {child}
                  </React.Fragment>
                );
              } else {
                return child;
              }
            })}
          </section>
        </aside>
        : null,
      document.body
    )
  );
}



// WEBPACK FOOTER //
// ./src/app/Components/Modal.jsx